// GA4, through the single gtag.js loaded in index.html.
//
// index.html carries Google's own snippet for G-R1WYF07J8W, the property the
// inqmisetechnologies.com web stream belongs to. This file used to load a
// second copy of gtag through react-ga4 for a different property
// (G-HSSS5S3YGQ) — so the stream GA4 shows for this site never received a hit,
// and on top of that the CSP blocked region1.google-analytics.com, where GA4
// sends them.
//
// Page views need no code here. Each `config` sends the first one, and GA4's
// Enhanced Measurement ("page changes based on browser history events", on by
// default) records every in-app navigation. Sending page_view manually as
// well was measured to double-count every navigation after the first, so
// don't add it back unless Enhanced Measurement is turned off for the stream.
//
// The old property keeps receiving data through the same gtag, so its history
// does not stop. Remove LEGACY_ID once it is no longer needed.

const LEGACY_ID = "G-HSSS5S3YGQ";

export const initGA = () => {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }
  window.gtag("config", LEGACY_ID);
};
